import { render, staticRenderFns } from "./BasalamVariation.vue?vue&type=template&id=1261060c&scoped=true"
import script from "./BasalamVariation.vue?vue&type=script&lang=js"
export * from "./BasalamVariation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261060c",
  null
  
)

export default component.exports